import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import { getProducts } from '../services/api';
import './SearchResultsPage.css';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function SearchResultsPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const query = useQuery();
  const searchTerm = query.get('termo');

  useEffect(() => {
    if (!searchTerm) return;

    const fetchProducts = async () => {
      try {
        setLoading(true);
        const response = await getProducts(1, 100, null, searchTerm); // page=1, limit=100, category=null, search=searchTerm
        setProducts(response.products || []);
      } catch (err) {
        setError('Falha ao buscar os produtos. Tente novamente mais tarde.');
        console.error('Erro em SearchResultsPage:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [searchTerm]);

  return (
    <div className="search-results-page">
      <h2>Resultados da busca por: "{searchTerm}"</h2>
      {loading ? (
        <p>Carregando...</p>
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : products.length > 0 ? (
        <div className="products-grid"> {/* Mantendo consistência com HomePage */}
        {products.map(product => (
          <div key={product.code || product.id} className="product-grid-item"> {/* Usar 'code' como chave principal */}
            <ProductCard product={product} />
          </div>
        ))}
      </div>
      ) : (
        <p>Nenhum produto encontrado para esta busca.</p>
      )}
    </div>
  );
}

export default SearchResultsPage;
